import { ChangeDetectorRef, Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AHSTripettoComponent } from '@nx-ahs/script-collector';
import { AhsTextComponent } from '@nx-ahs/base-ahs-controls/reactive';
import { Subscription } from 'rxjs';

@Component({
	selector: 'nx-ahs-finance-text',
	templateUrl: './finance-text.component.html',
	styleUrls: ['./finance-text.component.scss'],
	standalone: true,
	imports: [CommonModule, ReactiveFormsModule, AhsTextComponent]
})
export class FinanceTextComponent extends AHSTripettoComponent implements OnDestroy, AfterViewInit, OnInit {
	public customValidationMessages: Map<string, string>;
	public formGroup: FormGroup;
	public pattern: string = '^[0-9]*(.[0-9]{2})?$';
	public placeholder: string = '';
	public label: string;
	public description: string;
	public maxValue: number = 0;
	public data;
	public invertAmount;
	public showRemaining;
	public lessThanAmount;

	public loadData;
	public tripData;

	private subscriptions: Subscription[] = [];

	constructor(
		private formBuilder: FormBuilder,
		private changeDetectorRef: ChangeDetectorRef
	) {
		super();
	}

	ngOnInit(): void {
		this.buildForm();
	}

	private buildForm() {
		this.formGroup = this.formBuilder.group({
			amount: [null, []]
		});
	}

	ngOnDestroy(): void {
		this.subscriptions.forEach((s) => s.unsubscribe());
	}

	async ngAfterViewInit(): Promise<void> {
		await this.load();

		this.maxValue = this.figureMaxValue();
		this.formGroup.controls['amount'].setValidators([
			Validators.required,
			Validators.pattern(this.pattern),
			Validators.max(this.maxValue)
		]);

		this.changeDetectorRef.detectChanges();
	}

	public compareWith(o1: any, o2: any): boolean {
		return o1.relationshipId == o2.relationshipId;
	}

	private async load(): Promise<void> {
		this.loadData = null;
		if (this.scriptJsonStr) {
			this.tripData = this.scriptJsonStr.replace('\\', '').replace('... ', '').replace(' ...', '') as any;
		}
		if (this.tripData) {
			this.loadData = JSON.parse(this.tripData);
		}

		this.changeDetectorRef.detectChanges();
	}

	public markAllFieldsAsTouched() {
		// Since the Tripetto script only simply checks for "required", i.e. having a value (simple, JSON, whatever),
		// it doesn't care about specific validation of the sub-controls of the inner form... so in the case of
		// a validation error, we'll set "null" to fail the simple "required" idea.
		this.setTripettoValue(this.formGroup.valid ? this.formGroup.controls['amount'].value : null);

		Object.keys(this.formGroup.controls).forEach((key) => {
			this.formGroup.get(key).markAsTouched();
		});
	}

	public figureMaxValue(): number {
		let maxValue: number = 0;
		if (this.loadData && this.loadData.length > 0) {
			this.loadData.forEach((d) => {
				if (d.paymentBalance) {
					maxValue += d.paymentBalance;
				}
			});
		} else if (this.loadData && typeof this.loadData == 'object') {
			maxValue = this.loadData.paymentBalance;
		}

		if (this.invertAmount && maxValue < 0) {
			// if the concept of balances is that a negative number  means they have extra money, convert to positive
			maxValue = maxValue * -1;
		}

		if (this.lessThanAmount) {
			maxValue = maxValue - this.lessThanAmount;
		}

		return maxValue;
	}
}
